/**
 * Created by linjianxi on 2016/11/10.
 */
export const WECHART_PAY = 'WECHART_PAY'
export const ALIBABA_PAY = 'ALIBABA_PAY'
export const PAY_LIST = 'PAY_LIST'
export const ALIPAY_HTML = 'ALIPAY_HTML'
export const USER_INFOR = 'USER_INFOR'
export const GET_CODE_IMG = 'GET_CODE_IMG'
export const SWITCH_USER = 'SWITCH_USER'



// WEBPACK FOOTER //
// ./src/vuex/modules/pay_test/mutation-type.js